const files = require.context('.', false, /\.json$/);
const sites = {};

files.keys().forEach( (key) => {
	if (key === './index.js') return
	sites[ key.replace(/(\.\/|\.json)/g, '') ] = files( key )
});

export default sites